/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import FormTitle from "../FormTitle/FormTitle";
import FormStartBox from "./FormStartBox/FormStartBox";
import classes from "./FormStart.module.scss";
import singleTix from "../../assets/images/singleTix.png";
import largeGroupTix from "../../assets/images/largeGroupTix.png";
import packageTix from "../../assets/images/packageTix.png";
import headerBannerDesktop from "../../assets/images/Extended_nats.com_2610x1044REV.jpg";
import headerBannerMobile from "../../assets/images/TICKETFINDER HEADER_614x500.jpg";
import * as CONSTANT from "../../constants/routes";
import * as ROUTES from "../../constants/routes";
import FormController from "../../components/FormController/FormController";
const FormStart = (props) => {
  useEffect(() => {
    props.updateMultipleSelectedChoices({
      [ROUTES.PAGE_1_KEY]: "",
      [ROUTES.PAGE_2_KEY]: "",
      [ROUTES.PAGE_3_KEY]: "",
      // [ROUTES.PAGE_4_KEY]: {},
      [ROUTES.PAGE_5_KEY]: "",
      selectYourSeatsUuid: "",
      buid: "",
      seatInfoSelected: "",
      numOfSeat: "",
      // benefitSubmit: false
    });

    // if (props.formStart !== "") {
    if (window.adobeAnalytics) {
      window.adobeAnalytics.t({
        pageName:
          "Washington Nationals: Tickets: Nationals Ticketfinder: Form Start",
      });
    }
    // }
  }, []);

  return (
    <div>
      <FormTitle title="Looking For Nationals Tickets?" />
      {/* <div className={classes.headerBannerDesktop}>
        <img src={headerBannerDesktop} alt="" />
      </div>
      <div className={classes.headerBannerMobile}>
        <img src={headerBannerMobile} alt="" />
      </div> */}
      <div className={classes.FormStartBox}>
        {/* <p className={classes.covid19}>
          After continued discussion and planning with the Government of the
          District of Columbia, health experts and Major League Baseball, we are
          excited to announce that we will be expanding to full capacity at
          Nationals Park, beginning with our June 10 game.
          <br />
          <br />
          We are on sale to fans looking to purchase new 2021 season plans!
          Since our options have changed to conform with our new seating
          capacity, please click "Chat with a Representative" below to learn
          more about our current offerings.
          <br />
          <br />
          For additional information, including Frequently Asked Questions,
          please visit{" "}
          <a
            href="http://nationals.com/2021ticketinfo"
            target="_blank"
            rel="noopener noreferrer"
          >
            nationals.com/2021ticketinfo
          </a>
          .
        </p> */}
       <FormStartBox
          icon={singleTix}
          iconStyle={{ maxWidth: "49px" }}
          title="Tickets to a<br />Single Game"
          description="Choose your game from a season full of exciting giveaways, theme games, and special promotions."
          buttonName="Select"
          buttonLink="https://www.mlb.com/nationals/tickets/single-game-tickets?affiliateId=was-ticketfinder-041221"
          externalLink={true}
          updateSelectedChoices={() => {
            if (window.adobeAnalytics && window.adobeAnalytics.tl) {
              window.adobeAnalytics.tl(
                true,
                "o",
                "Washington Nationals: Tickets: Nationals Ticketfinder: Form Start: Tickets to a Single Game : select button click",
                {
                  prop12: "Nationals TicketFinder",
                  prop13:
                    "Washington Nationals: Tickets: Nationals Ticketfinder: Form Start",
                  prop14: "Tickets to a Single Game : select button click",
                }
              );
            }
            // props.updateSelectedChoices(
            //   CONSTANT.PAGE_1_KEY,
            //   CONSTANT.PAGE_1_CHOICES_1
            // );
          }}
        />
        <FormStartBox
          icon={largeGroupTix}
          iconStyle={{ maxWidth: "82px" }}
          title="Tickets for a<br />Large Group"
          description="For groups of 13 or more: the bigger your group, the bigger your discount."
          buttonName="Select"
          buttonLink="ticket-large-group"
          // externalLink="chat"
          updateSelectedChoices={() => {
            if (window.adobeAnalytics && window.adobeAnalytics.tl) {
              window.adobeAnalytics.tl(
                true,
                "o",
                "Washington Nationals: Tickets: Nationals Ticketfinder: Form Start: Tickets for a Large Group : select button click",
                {
                  prop12: "Nationals TicketFinder",
                  prop13:
                    "Washington Nationals: Tickets: Nationals Ticketfinder: Form Start",
                  prop14: "Tickets for a Large Group : select button click",
                }
              );
            }
            props.updateSelectedChoices(
              CONSTANT.PAGE_1_KEY,
              CONSTANT.PAGE_1_CHOICES_2
            );
          }}
        />
 <FormStartBox
          icon={packageTix}
          iconStyle={{ maxWidth: "61px" }}
          title="Multi-Game<br />Ticket Plans"
          description="TicketFinder can help you customize a 2022 plan with unbeatable pricing and exclusive benefits."
          buttonName="Coming Soon"
          buttonLink="style-of-plan"
          // externalLink="chat"
          updateSelectedChoices={() => {
            if (window.adobeAnalytics && window.adobeAnalytics.tl) {
              window.adobeAnalytics.tl(
                true,
                "o",
                "Washington Nationals: Tickets: Nationals Ticketfinder: Form Start: multi-game ticket plans : select button click",
                {
                  prop12: "Nationals TicketFinder",
                  prop13:
                    "Washington Nationals: Tickets: Nationals Ticketfinder: Form Start",
                  prop14: "multi-game ticket plans : select button click",
                }
              );
            }
            props.updateSelectedChoices(
              CONSTANT.PAGE_1_KEY,
              CONSTANT.PAGE_1_CHOICES_3
            );
          }}
        />
        
        {/* <p className={classes["covid19--no-border"]}>
          <span className={classes.covid19_2}>
            Use your FREE 50% Bonus Credit* on concessions, merchandise,
            additional tickets and more!
          </span>
        </p>
        <p className={classes["covid19--no-border"]}>
          *50% Bonus Credit calculated based on the amount paid towards
          qualifying new 2021 ticket plans on or before December 15, 2020, less
          all associated fees. For 50% Bonus Credit program terms & conditions,
          please visit{" "}
          <a
            href="http://www.nationals.com/bonusterms"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.nationals.com/bonusterms
          </a>
          .
        </p> */}
      </div>
      <FormController
        backTo={ROUTES.PAGE_1_LINK}
        nextTo={ROUTES.PAGE_3_LINK}
        startOver={ROUTES.PAGE_1_LINK}
        showBack={false}
        showStartOver={false}
        showSkip={false}
        showSubmit={false}
      />
    </div>
  );
};

export default FormStart;
